export default __webpack_public_path__ + "static/media/bootstrap-4.997c463d.svg";